/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-03-29 14:10:36
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace AliyunPad {
    /**
     * 获取供应商列表
     */
    export var GetAliyunSTS = (): Promise<any> => {
        return Get(`/api/Aliyun/GetAliyunSTS`, {});
    };
    
   
  
    
}



// WEBPACK FOOTER //
// ./src/http/api_AliyunPad.ts